
import { PropOptions } from 'vue';
import mixins from 'vue-typed-mixins';

import CustomInputComponent from '@/components/mixins/custom-input-component';

export default mixins(CustomInputComponent).extend({
  name: 'FormTreatmentSelectionControl',
  props: {
    value: {
      type: Array,
      default: () => [],
    } as PropOptions,
    availableTreatments: {
      type: Array,
      default: () => [],
    } as PropOptions,
  },
  data() {
    return {
      open: true,
    };
  },
  computed: {
    uniqueTreatments() {
      return this.availableTreatments;
    }
  },
  methods: {
    checkboxClickHandler(id: number): void {
      let result = this.value;

      if (this.isSelected(id)) {
        result = result.filter((treatment) => treatment.id !== id);
      } else {
        const treatment = this.availableTreatments.find(t => t.id === id);
        if (treatment) {
          result.push({ id: treatment.id, title: treatment.title });
        }
      }
      this.$emit('input', result);
    },
    isSelected(id: number): boolean {
      return this.value.find((treatment) => treatment.id === id) ? true : false;
    },
    toggle() {
      this.open = !this.open;
    },
  },
});
